<template>
  <div
    :class="[
      $style.root,
      {
        [$style.disabled]: disabled,
        [$style.alert]: alert,
        [$style.deselect]: deselect,
      },
    ]"
    @keydown="onCheckboxKeyDown"
  >
    <slot :checked="checked" />
  </div>
</template>

<script setup lang="ts">
import { onCheckboxKeyDown } from "./checkableKeyboard";

withDefaults(
  defineProps<{
    disabled?: boolean;
    checked?: boolean;
    alert?: boolean;
    deselect?: boolean;
  }>(),
  {
    disabled: false,
    checked: false,
    alert: false,
    deselect: false,
  },
);
</script>

<style lang="scss" module>
@use "../styles/helpers/checkable.scss" as Checkable;

.root {
  @include Checkable.checkbox($indeterminate: ".deselect:has(input:checked)", $disabled: ".disabled");

  &.alert {
    --sca-checkbox-border-color: var(--color-interaction-border-alert);
  }
}
</style>
